import BaseModel from './BaseModel';
import {ATTRIBUTE_TYPES, HitContainerAttribute} from '../../components';
import {required} from '@vuelidate/validators';
import QmSubject from './QmSubject';
import {$d} from '../../plugins/i18n/i18n';

const getNewestDocument = (documentList) => {
  if (!documentList || documentList.length === 0) {
    return null;
  }

  documentList = documentList.sort(
    (a, b) => new Date(b.creationDate) - new Date(a.creationDate)
  );

  return documentList[0];
};

export default class QmDocument extends BaseModel {
  constructor({
    id,
    designation = undefined,
    subject = undefined,
    creation_date = undefined,
    modification_date = undefined,
  }) {
    super(id, '', designation);
    this.designation = designation;
    this.subject = subject ? new QmSubject(subject) : undefined;
    this.creation_date = creation_date;
    this.modification_date = modification_date;
  }

  static get fkName() {
    return 'qm_subject_id';
  }

  get fkName() {
    return QmDocument.fkName;
  }

  get detailPageRoute() {
    return QmDocument.detailPageRoute;
  }

  static get detailPageRoute() {
    return 'qmDocumentDetail';
  }

  static get apiRoute() {
    return 'qm_document';
  }

  static get listPageRoute() {
    return 'QmDocumentDetail';
  }

  get apiRoute() {
    return QmDocument.apiRoute;
  }

  static get joinAttrsKey() {
    return ['subject', 'designation', 'dateCreationByDocument', 'version'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      ['designation', 'dateCreationByDocument', 'version'],
      ['documents']
    );
  }

  static get detailAttrs() {
    return this.getAttributes(
      ['designation', 'documents', 'dateCreationByDocument', 'version'],
      ['documents']
    );
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'designation',
      'documents',
      'dateCreationByDocument',
      'version',
    ]);
  }

  static get allAttributes() {
    return {
      designation: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        validations: {required},
        tableProperties: {
          header: 'hit-app.common.designation',
          maxWidth: '2fr',
        },
      }),
      subject: new HitContainerAttribute(ATTRIBUTE_TYPES.FK_QM_SUBJECT, {
        joinPath: ['qm_subject!fk_qm_document_qm_subject_id_qm_subject'],
        fkToUpdate: 'qm_subject_id',
        tableProperties: {
          header: 'hit-app.common.qm_subject',
        },
      }),
      creation_date: new HitContainerAttribute(ATTRIBUTE_TYPES.DATE, {
        tableProperties: {
          header: 'hit-app.common.creation-date',
        },
      }),
      modification_date: new HitContainerAttribute(ATTRIBUTE_TYPES.DATE, {
        tableProperties: {
          header: 'hit-app.common.modification-date',
        },
      }),
      // Get datas from document table
      documents: new HitContainerAttribute(ATTRIBUTE_TYPES.FK_FILE_DOCUMENT, {
        joinPath: ['fk_document_qm_document_id_qm_document'],
      }),
      dateCreationByDocument: new HitContainerAttribute(
        ATTRIBUTE_TYPES.NOT_FETCHED,
        {
          readOnly: true,
          tableProperties: {
            header: 'hit-app.common.date',
            maxWidth: '1fr',
            readOnly: true,
          },
          transform: (data) => {
            const newestDocument = getNewestDocument(data.documents);
            if (newestDocument) {
              return $d(newestDocument.creationDate, 'long');
            }
            return '';
          },
        }
      ),
      version: new HitContainerAttribute(ATTRIBUTE_TYPES.NOT_FETCHED, {
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.version',
          maxWidth: '0.50fr',
          readOnly: true,
        },
        transform: (data) => {
          const newestDocument = getNewestDocument(data.documents);
          if (newestDocument) {
            return newestDocument.version;
          }
          return '';
        },
      }),
    };
  }
}
